var map = {
	"./android@2x.png": "jmRh",
	"./apple@2x.png": "z4eJ",
	"./home_m_1.png": "zWh/",
	"./home_m_2.png": "jPQu",
	"./home_m_3.png": "7ihy",
	"./home_m_4.png": "xsf8",
	"./home_pc_1.png": "1CDo",
	"./home_pc_2.png": "EGgG",
	"./home_pc_3.png": "u9l4",
	"./home_pc_4.png": "GqPy",
	"./hugou@2x.png": "wRRg",
	"./icp_public.png": "kEUJ",
	"./logo.png": "7Otq",
	"./qrcode_comment.png": "74dH",
	"./qrcode_goudrive.png": "qsda",
	"./qrcode_im.png": "V2QT",
	"./qrcode_work.png": "eYYy",
	"./step01@2x.png": "iV2G",
	"./step02@2x.png": "PqTS",
	"./styles/main.scss": "H/op",
	"./win@2x.png": "dey2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0